<template>
    <div>
        <v-dialog v-model="showDialog" width="450">
            <v-card class="mx-auto pt-7 pb-2">
                <v-alert color="orange"
                         prominent
                         text
                         icon="mdi-clock-outline">{{$t("Kalan Süre")}}: {{timeremaining}} {{$t("Saniye")}}</v-alert>
                <v-card-text class="text-center" v-html="messageBody">
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text :color="color" class="white--text font-weight-bolder px-5" @click="CloseDialog()">
                        {{$t("AL_Yes")}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<style>
    #idlistofnotif::-webkit-scrollbar {
        width: 10px;
    }

    #idlistofnotif::-webkit-scrollbar-track {
        background: #fdfdfd20;
        border-radius: 10px;
    }

    #idlistofnotif::-webkit-scrollbar-thumb {
        background: #fdfdfd80;
        border-radius: 10px;
    }

        #idlistofnotif::-webkit-scrollbar-thumb:hover {
            background: #ffffffA0;
        }
</style>
<script>
    import axios from 'axios';
    import 'material-design-icons-iconfont/dist/material-design-icons.css';
    import { FormMixIn } from '@/MixIns/FormMixins';
    import Utilities from '@/Utilities.js'

    import Vue from 'vue';
    import alertIcon from './alertIcon';
    Vue.component('alertIcon', alertIcon);

    export default {
        name: 'showdialogtimer',
        props: {
            message: Object
        },

        data() {
            return {
                vicon: 'warning',
                color: 'orange',
                timeout: 60,
                timeremaining: -1,
                messageBody: '',
                timerId: null,
                OnTimeoutCallback: undefined,
                OnApproveCallback: undefined,
                showDialog: false,
            };
        },
        mixins: [FormMixIn],
        mounted() {
            this.$root.$on('setUpDialogTimer', (data) => {
                Utilities.log("setUpDialogTimer ===> ", data);

                this.messageBody = data.messageBody;
                this.OnTimeoutCallback = data.OnTimeoutCallback;
                this.OnApproveCallback = data.OnApproveCallback;
                this.timeout = data.timeout;
                this.timeremaining = data.timeout;
                
                this.showDialog = true;
            });
        },

        methods: {
            CloseDialog() {
                this.showDialog = false;
            },
        },
        watch: {
            timeremaining:
            {
                handler(value)
                {
                    if (value == 0)
                    {
                        this.CloseDialog();
                    }
                    else
                    {
                        this.timerId = setTimeout(() =>
                        {
                            this.timeremaining--;
                        }, 1000);
                    }
                },
                deep: true
            },
            showDialog: function (newValue, oldValue) {
                if (oldValue)
                {
                    clearTimeout(this.timerId);
                    if (this.timeremaining == 0)
                    {
                        Utilities.log('Close timer dialog with result', "Timeout");
                        this.OnTimeoutCallback();
                    }
                    else
                    {
                        Utilities.log('Close timer dialog with result', "User Active");
                        this.OnApproveCallback();
                    }
                }
            }
        }
    };
</script>
